import { Calendar } from "lucide-react";

declare global {
  interface Window {
    Cal?: any;
  }
}

const CAL_LINK = "tabletalktv";
const NS = "popup";

let calInitialized = false;

const ensureCalLoaded = () => {
  if (calInitialized) return;
  calInitialized = true;
  (function (C: any, A: string, L: string) {
    const p = function (a: any, ar: any) {
      a.q.push(ar);
    };
    const d = C.document;
    C.Cal =
      C.Cal ||
      function () {
        const cal = C.Cal;
        // eslint-disable-next-line prefer-rest-params
        const ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement("script")).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api: any = function () {
            // eslint-disable-next-line prefer-rest-params
            p(api, arguments);
          };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === "string") {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ["initNamespace", namespace]);
          } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
  })(window, "https://app.cal.com/embed/embed.js", "init");

  const Cal = window.Cal!;
  Cal("init", NS, { origin: "https://cal.com" });
  Cal.ns[NS]("ui", {
    styles: { branding: { brandColor: "#F5C518" } },
    hideEventTypeDetails: false,
    layout: "month_view",
  });
};

const CalEmbed = () => {
  const openPopup = () => {
    ensureCalLoaded();
    const Cal = window.Cal;
    if (Cal && Cal.ns && Cal.ns[NS]) {
      Cal.ns[NS]("modal", {
        calLink: CAL_LINK,
        config: { layout: "month_view" },
      });
    } else {
      window.open(`https://cal.com/${CAL_LINK}`, "_blank", "noopener");
    }
  };


  return (
    <div className="bg-white/95 backdrop-blur-md border border-[var(--color-border)] rounded-2xl p-6 shadow-xl text-center">
      <p className="uppercase tracking-wider text-[10px] font-bold text-brand mb-2">
        Book a Call
      </p>
      <h3 className="font-bold text-2xl leading-tight text-[var(--color-text)] mb-3">
        Grab a 5-minute slot
      </h3>
      <p className="text-muted-custom text-sm mb-6">
        Pick a time that works for you - opens in a quick popup.
      </p>
      <button
        type="button"
        onClick={openPopup}
        className="btn-primary w-full px-8 py-4 text-base"
      >
        <Calendar className="w-5 h-5" />
        Open Booking Calendar
      </button>
    </div>
  );
};

export default CalEmbed;
